import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import tabbar from "@/components/tabbar/tabbar.vue";
import ElementUI from 'element-ui';
import "vant/lib/index.css";
import "@/utils/index.scss";
import 'element-ui/lib/theme-chalk/index.css';
Vue.component("tabBar", tabbar);
Vue.config.productionTip = false;
Vue.use(Vant);

Vue.use(ElementUI);
// 关键：忽略微信开放标签的编译检查，让标签正常渲染
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

new Vue({
  router,
  store,
  el: '#app',
  render: (h) => h(App),
}).$mount("#app");
